
/**
 * Execute in windowLoad() so the loader
 * goes away as soon as the page is loaded.
 * Remove it from the DOM after X seconds, just in case.
 */
function stickyHeader() {

    var myOffcanvas = document.getElementById('offcanvas-menu-wrapper');
    myOffcanvas.addEventListener('show.bs.offcanvas', function (){
        document.querySelector('body').classList.add('opened-canvas');
    })
    myOffcanvas.addEventListener('hide.bs.offcanvas', function (){
        document.querySelector('body').classList.remove('opened-canvas');
    })

    window.addEventListener('scroll', () => {

        var body = document.querySelector('body'); 

        // distance from Sticky Navbar to top
        var stickyElementOffsetTop = 0;

        // original vertical scroll position
        var originalScrollPos = window.pageYOffset || document.documentElement.scrollTop;; 
        // current vertical scroll position
        var currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;;

        // [SNIPPET] is Sticky Navbar sticked?
        if (currentScrollPos > stickyElementOffsetTop) {
            body.classList.add('sticked-header');
        } else {
            body.classList.remove('sticked-header');
        }
        // end

        // [SNIPPET] is user scrolling down or up?
        if (currentScrollPos > originalScrollPos) {
            body.classList.add('scrolling-down');
            body.classList.remove('scrolling-up');
        } else {
            body.classList.add('scrolling-up');
            body.classList.remove('scrolling-down');
        }
        // end

        // [SNIPPET] did user scroll way 2 much?
        if (currentScrollPos >= 280) {
            body.classList.add('has-scrolled');
        }
        else {
            body.classList.remove('has-scrolled');
        }
        // end

        originalScrollPos = currentScrollPos;
    });
}

document.addEventListener('DOMContentLoaded', () => {
    stickyHeader();
});

